import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=3c73dcb1"
import script from "./Fullscreen.vue?vue&type=script&lang=js"
export * from "./Fullscreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c73dcb1')) {
      api.createRecord('3c73dcb1', component.options)
    } else {
      api.reload('3c73dcb1', component.options)
    }
    module.hot.accept("./Fullscreen.vue?vue&type=template&id=3c73dcb1", function () {
      api.rerender('3c73dcb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/Fullscreen.vue"
export default component.exports